import { GridColDef } from "@mui/x-data-grid";
import { atom } from "jotai";

export const VerbatimColumns = atom<GridColDef[]>([]);
export const ExpandedRowsAtom = atom<string[]>([]);
